module.exports = __webpack_public_path__ + "img/IMG_8263.c7af14e7.jpeg";